/*
represents open-ended JSON object for Communication settings
for MVP the cs1 cachefile is the only setting, but there will be more down the road
*/

import MessageSettings from "./MessageSettings";

class CommunicationSettings {
  type: string; //"direct contact" | "notification"
  priority: string; //  A text value of high, normal, or low. More urgent interactions get priority in terms of the relevance for the contents of the message and the order of any interaction summaries or content embedded in an email message.
  notification_minimum_frequency: number | string; // An interval of time consisting of an integer and a unit representing how often to repeat the communication.
  message: MessageSettings ; // An html text value defining the content of the message sent to the patient to remind them to complete the interaction. If the communication is direct content then the message precedes the content.
  notification_strategy?: string | null | undefined;
  count?: string | number | null | undefined;
  notification_minimum_frequency_unit?: string | null | undefined
  constructor(
    type: string, //"direct contact" | "notification"
    priority: string, //  A text value of high, normal, or low. More urgent interactions get priority in terms of the relevance for the contents of the message and the order of any interaction summaries or content embedded in an email message.
    notification_minimum_frequency: number | string, // An interval of time consisting of an integer and a unit representing how often to repeat the communication.
    message: MessageSettings , // An html text value defining the content of the message sent to the patient to remind them to complete the interaction. If the communication is direct content then the message precedes the content.
    notification_strategy?: string | null | undefined,
    count?: string | number | null | undefined,
    notification_minimum_frequency_unit?: string | null | undefined

  ) {
    this.type = type;
    this.priority = priority;
    this.message = message;
    this.notification_minimum_frequency = notification_minimum_frequency;
    this.notification_strategy = notification_strategy;
    this.count = count;
    this.notification_minimum_frequency_unit = notification_minimum_frequency_unit;

  }
}

export default CommunicationSettings;
